import React, { useEffect, useState } from "react";
import { DollarSign } from "lucide-react";
import api from "@/lib/api";

export default function RateCard() {
  const [rows, setRows] = useState([]);
  const [base, setBase] = useState(5);

  useEffect(() => {
    api.get("/ads/rate-card").then((r) => { setRows(r.data.segments || []); setBase(r.data.base_cpm_usd || 5); }).catch(() => {});
  }, []);

  const byCat = rows.reduce((acc, r) => { (acc[r.category] = acc[r.category] || []).push(r); return acc; }, {});

  return (
    <div className="max-w-3xl mx-auto px-4 py-8 animate-slide-up" data-testid="rate-card-page">
      <div className="flex items-center gap-2 mb-1">
        <DollarSign size={20} className="text-race-volt" />
        <h1 className="font-heading text-4xl">Sponsor Rate Card</h1>
      </div>
      <p className="text-race-sub text-sm mb-6">Live CPM by interest segment (per 1,000 impressions). Base rate ${base.toFixed(2)}; higher-demand segments cost more.</p>

      {Object.keys(byCat).sort().map((cat) => (
        <div key={cat} className="mb-6">
          <div className="overline text-race-sub mb-2">{cat}</div>
          <div className="bg-race-surface border border-race-line rounded-lg divide-y divide-race-line/50">
            {byCat[cat].map((r) => (
              <div key={r.tag} className="flex items-center justify-between px-4 py-2.5" data-testid={`rate-${r.tag}`}>
                <div>
                  <div className="font-medium text-race-txt">{r.tag}</div>
                  <div className="text-[11px] text-race-sub">{r.reach} reachable members · {r.advertisers} advertiser(s)</div>
                </div>
                <div className="font-mono text-race-volt text-lg">${r.suggested_cpm_usd.toFixed(2)}<span className="text-race-sub text-xs"> CPM</span></div>
              </div>
            ))}
          </div>
        </div>
      ))}
      {rows.length === 0 && <div className="text-center text-race-sub py-16">Rate card loading…</div>}
    </div>
  );
}
